import { Avatar, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import type { IProjectParticipatingTeam } from '../../api/types/projects'
import { routesProfile } from '../../consts'

type Props = {
  teams: IProjectParticipatingTeam[]
}

export const ParticipatingTeamsSection = ({ teams }: Props) => {
  const navigate = useNavigate()

  if (teams.length === 0) {
    return null
  }

  return (
    <Stack gap={1.5}>
      <Typography variant="black-14-medium">
        Команды проекта: {teams.length}
      </Typography>
      <Stack gap={1}>
        {teams.map((team) => (
          <Stack
            key={team.id}
            direction="row"
            gap={1.25}
            alignItems="center"
            sx={{ cursor: 'pointer', width: '100%' }}
            onClick={() => navigate(`/${routesProfile.TEAMS.path}/${team.slug || team.id}`)}
          >
            <Avatar src={team.image ?? undefined} alt={team.name} sx={{ width: 36, height: 36 }}>
              {team.name.trim().charAt(0) || '?'}
            </Avatar>
            <Stack minWidth={0}>
              <Typography variant="black-12-light" noWrap>
                {team.name}
              </Typography>
              {team.slogan?.trim() && (
                <Typography variant="black-12-light" color="text.secondary" noWrap>
                  {team.slogan}
                </Typography>
              )}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}
